import React from 'react';
import { ConfigContext } from '../../../config/context';
// @ts-ignore
import * as config from '../../../config/index.js';
import { I18nContext } from '../../../i18n/context';
import { BigPreloader } from '../../../shared/atoms/preloaders/general';
import { usePageLoader } from '../../../shared/hooks/use-page-loader';
import '../../../styles/global/index.sass';
import '../../../styles/mediaQuery/mobile.css';
import '../../../styles/mediaQuery/laptop.css';
import '../../../styles/mediaQuery/desktop.css';
import { useViewModel } from './hook/use-view-model';
import { DocumentProps } from './type/props';

export const Document = (props: DocumentProps) => {
  const { isLoading } = usePageLoader();
  useViewModel();

  return (
    <I18nContext.Provider value={{ t: props.t, locale: props.locale, supportedLocales: props.supportedLocales }}>
      <ConfigContext.Provider value={{ ...config }}>
        {isLoading ? <BigPreloader /> : props.children}
      </ConfigContext.Provider>
    </I18nContext.Provider>
  );
};
